import React from 'react'
import TasksTimelineCard from './TasksTimelineCard'
import {useState, useEffect} from 'react';
import {Buffer} from 'buffer';
import { Rings } from 'react-loader-spinner'

export default function TasksTimelines() {

    const [executions, setExecution] = useState([]);
    const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_ENDPOINT
    const user = process.env.REACT_APP_USER
    const pass = process.env.REACT_APP_PASS
    const base64encodedData = Buffer.from(`${user}:${pass}`).toString('base64');
    
    const searchExecutions = async(name) => {
        const response = await fetch(`${CUSTOMER_API_URL}/customer_execute/executions/?search=${name}`, {
          method: 'GET',
          headers: {'Content-Type': 'application/json','Authorization': 'Basic ' + base64encodedData}})
        const data = await response.json();
        setExecution(data);
      }
    
    useEffect(() => {
      searchExecutions('');
    }, [])
    
  return (
        <div className="col-lg-4 col-md-6">
          <div className="card h-100">
            <div className="card-header pb-0">
              <h6>Tasks Timeline</h6>
              <p className="text-sm">
                <i className="fa fa-arrow-up text-success" aria-hidden="true"></i>
                <span className="font-weight-bold">
                {executions?.length > 0 ?
                    (
                      executions.length
                    ) : (    
                    "Nothing yet"
                    )
                }
                </span> this month
              </p>
            </div>
            <div className="card-body p-3">
                {executions?.length > 0 ?
                    (
              <div className="timeline timeline-one-side">
                {/*ICON NAMES notifications, code, shopping_cart, credit_card, key, payments */}

                {executions.map ((execution) => (
                        <TasksTimelineCard key={execution.id} execution={execution}/>
                      ))}
                
              </div>
                    ) : (
                        <Rings
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="rings-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        />
                    )
                }
            </div>
          </div>
        </div>
        )
}
